import { Dispatch, SetStateAction } from "react"
import { Formik } from "formik"
import { makeStyles } from "tss-react/mui"
import { MeetingServiceOrder } from "../../../../modules/merchant/accounting/accounting/accountingTypes"
import { getCustomFieldsValues } from "../components/form/formLib"
import { ButtonConfigType } from "../../filters/orderTypeFilter/StandardOrderTypeFilter"
import { OrderContextState, OrderFormStatus } from "./helpers"
import { MainOrderFormikRef, MeetingServiceTabValues } from "../components/form/formTypes"
import { SelectedMainUserState, CreateOrderDialogFlow, CreateOrderDialogType } from "../createOrderTypes"
import { OutlookBookingSuccessArgs } from "../../../../modules/order/pages/outlookCreateOrderTypes"
import { useDateTime } from "../../../../modules/localization/useDateTime"
import { CreateOrderType } from "../helpers"
import { OrderForm } from "./OrderForm"

const useStyles = makeStyles()((theme) => ({
    container: {
        minHeight: "100%",
        overflowX: "hidden",
        background: theme.palette.common.white,
    },
}))

type OrderFormContainerProps = Readonly<{
    user: SelectedMainUserState
    initialOrderType: CreateOrderType
    newOrderType: CreateOrderType | null
    dialogType: CreateOrderDialogType
    filteredTabButtonConfig: ButtonConfigType<CreateOrderType>[]
    handleClose: () => void
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    formikRef: MainOrderFormikRef
    orderContext: OrderContextState
    setOrderContext: Dispatch<SetStateAction<OrderContextState>>
    orderDetails?: MeetingServiceOrder
    flowConfig?: CreateOrderDialogFlow
    orderFormStatusRef: React.MutableRefObject<OrderFormStatus>
    handleOutlookBookingCompleted?: (args: OutlookBookingSuccessArgs) => void
}>

export function OrderFormContainer({
    user,
    initialOrderType,
    newOrderType,
    dialogType,
    filteredTabButtonConfig,
    handleClose,
    handleSubmitMeetingService,
    formikRef,
    orderContext,
    setOrderContext,
    orderDetails,
    flowConfig,
    orderFormStatusRef,
    handleOutlookBookingCompleted,
}: OrderFormContainerProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    const initialValues = getCustomFieldsValues(
        {
            event: null,
            resources: [],
            priceList: null,
            initPriceList: null,
            fullResourcesList: [],
        },
        dateTimeFactory,
        dialogType,
        orderDetails,
        orderContext.mode,
        flowConfig,
    )

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={() => {}}
            validateOnBlur={false}
            innerRef={formikRef}
            enableReinitialize
        >
            <div className={classes.container}>
                <OrderForm
                    user={user}
                    orderContext={orderContext}
                    initialOrderType={initialOrderType}
                    newOrderType={newOrderType}
                    dialogType={dialogType}
                    handleClose={handleClose}
                    filteredTabButtonConfig={filteredTabButtonConfig}
                    orderDetails={orderDetails}
                    flowConfig={flowConfig}
                    setOrderContext={setOrderContext}
                    orderFormStatusRef={orderFormStatusRef}
                    handleSubmitMeetingService={handleSubmitMeetingService}
                    outerFormik={formikRef}
                    handleOutlookBookingCompleted={handleOutlookBookingCompleted}
                />
            </div>
        </Formik>
    )
}
